<template>
    <div class="pageBox">
        <div class="cart" v-if="!isShowNoCart">
            <el-table
                :data="cartData"
                stripe
                border
                tooltip-effect="dark"
                ref="multipleTable"
                @selection-change="handleSelectionChange">
                style="width: 100%;">
                <el-table-column
                    type="selection"
                    align="center"
                    width="100px"
                >
                </el-table-column>
                <el-table-column
                    prop="goods"
                    label="商品"
                    align="center"
                    width="300px"
                >
                    <router-link
                        :to="{name:'ProductDetail',params:{pId:scope.row.productId}}"
                        class="goodsItem"
                        slot-scope="scope">
                        <div class="productImg">
                            <img :src="scope.row.productImg" alt="">
                        </div>
                        <div class="infoCol">
                            <div class="infoRow"
                                 :key="index"
                                 v-for="(item,index) in scope.row.paramValues">
                                <div class="name">{{ item.productParam }}:{{ item.paramValue }}</div>
                            </div>
                        </div>
                    </router-link>
                </el-table-column>
                <el-table-column
                    prop="unitPrice"
                    label="单价(元)"
                    align="center"
                >
                </el-table-column>
                <el-table-column
                    label="数量"
                    align="center"
                >
                    <el-input-number size="mini"
                                     slot-scope="scope"
                                     :min="1"
                                     :disabled="!isModifyNumber"
                                     @change="getProductInfo($event,scope.row.productId,scope.row.paramValues)"
                                     v-model="scope.row.number"></el-input-number>
                </el-table-column>
                <el-table-column
                    prop="totalPrice"
                    label="金额(元)"
                    align="center"
                >
                </el-table-column>
                <el-table-column
                    prop="handle"
                    label="操作"
                    align="center"
                >
                    <el-button slot-scope="scope" @click="confirm(scope.row.id)">删除</el-button>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page.sync="pageIndex"
                    :page-sizes="[5, 10, 15, 20]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalCount">
                </el-pagination>
            </div>
            <div class="bottomRow">
                <!--                selectedNumber > 0 ? '取消选择' : '全选'-->
                <el-button @click="toggleSelection()">取消选择</el-button>
                <div class="selected">
                    <span>已选商品：</span>
                    <span class="red">{{ selectedNumber }}</span>
                    <span>件</span>
                </div>
                <div class="hide">总计原价：￥51</div>
                <div>合计：<span class="red">￥{{ final_price }}</span></div>
                <div class="commit" @click="addOrder">提交订单</div>
            </div>
        </div>
        <div class="noCart" v-else>
            <img src="../assets/images/nocart.png" alt="购物车空">
            <div class="row1">
                <span>购物车暂时是空的，</span>
                <router-link class="link" to="/">去首页</router-link>
                <span>看看</span>
            </div>
            <span>选择您所需要的服务~</span>
        </div>
    </div>
</template>

<script>
export default {
    name: "cart",
    data() {
        return {
            isShowNoCart: false,
            cartData: [],
            //多选
            multipleSelection: [],
            pageSize: 10,
            pageIndex: 1,
            totalCount: 0,
            //控制是否可以修改商品数量
            isModifyNumber: true,
            // 勾选的产品数量
            selectedNumber: 0,
            //订单总金额
            final_price: 0,
            //购物车id
            cartId: 0
        }
    },
    mounted() {
        document.title = '我的购物车' + this.$suffix
        if (!this.$noLoginToLogin()) {
            this.getCartList()
        }
    },
    methods: {
        handleSizeChange(val) {
            this.pageSize = val
            this.getCartList()
        },

        handleCurrentChange(val) {
            this.pageIndex = val
            this.getCartList()
        },

        /**
         * 选中/取消按钮
         * @param rows
         */
        toggleSelection(rows) {
            if (rows) {
                rows.forEach(row => {
                    this.$refs.multipleTable.toggleRowSelection(row);
                });
            } else {
                this.$refs.multipleTable.clearSelection();
            }
        },
        /**
         * 获取选中行数据
         * @param val
         */
        handleSelectionChange(val) {
            //选中总件数
            this.selectedNumber = val.length
            //获取change列表
            this.multipleSelection = val;
            //获取订单总金额、购物车id
            if (val.length > 0) {
                this.cartId = val[0].id
                this.final_price = val[0].totalPrice
            } else {
                this.cartId = 0
                this.final_price = 0
            }
        },
        /**
         * 弹窗确认
         */
        confirm(id) {
            this.$confirm('将从购物车中移除该商品, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.deleteCart(id)
            }).catch(() => {

            });
        },

        /**
         * 获取购物车列表
         */
        getCartList() {
            this.$post('/V1/ShoppingCart/GetShopCartList',
                {
                    "userId": Number(this.$store.state.user.userName),
                    "pageSize": this.pageSize,
                    "pageIndex": this.pageIndex,
                })
                .then((res) => {
                    // console.log('shoppingCart', res)
                    if (res.success) {
                        this.cartData = []
                        this.cartData = res.response.data
                        this.totalCount = res.response.totalCount
                        this.isModifyNumber = true
                    } else {
                        this.$message.error("网络错误，请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("网络错误，请重试");
                })
        },

        /**
         * 删除购物车
         */
        deleteCart(id) {
            this.$post('/V1/ShoppingCart/DeleteShoppingCart',
                {
                    "id": id,
                    "userId": Number(this.$store.state.user.userName),
                })
                .then((res) => {
                    // console.log('delete', res)
                    if (res.success) {
                        this.$message({
                            type: 'success',
                            message: '移除产品成功！'
                        });
                        this.getCartList()
                    } else {
                        this.$message.error("网络错误，请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("网络错误，请重试");
                })
        },

        /**
         * 修改购物车
         */
        modifyCart(val, id, param) {
            // console.log('接收',param)
            this.$post('/V1/ShoppingCart/ModiyShoppingCart', {
                "userId": Number(this.$store.state.user.userName),
                "productId": Number(id),
                "number": val,
                "paramValues": param
            }).then((res) => {
                // console.log('modifyCart', res)
                if (res.success) {
                    this.getCartList()
                } else {
                    this.$message.error("网络错误，请重试");
                }
            }).catch(() => {

            })
        },

        /**
         * 获取产品id、参数id
         * @param id
         */
        getProductInfo(val, id, params) {
            // console.log(params)
            this.isModifyNumber = false
            let tmpList = []
            for (let i = 0; i < params.length; i++) {
                let param = {
                    "productParamValueId": Number(params[i].productParamValueId)
                }
                tmpList.push(param)
                // console.log('000',tmpList)
            }
            this.modifyCart(val, id, tmpList)
        },

        /**
         * 提交订单
         */
        addOrder() {
            let len = this.multipleSelection.length
            if (len < 1) {
                this.$message.warning("请先选择商品！")
                return
            } else if (len > 1) {
                this.$message.warning("一次只能勾选一种商品")
                return
            }

            this.$post('/V1/Order/AddOrderCart', {
                "userId": Number(this.$store.state.user.userName),
                "shoppingCartId": this.cartId,
                "addressId": 0
            }).then((res) => {
                // console.log('addOrder', res)
                if (res.success) {
                    this.$message.success("提交订单成功！");
                    this.getCartList()
                } else {
                    this.$message.error("网络错误，请重试");
                }
            }).catch(() => {

            })
        },
    }
}
</script>
<style scoped lang="less">

::v-deep .el-table thead tr th {
    background-color: #b4b4b4 !important;
    color: white;
}

.pageBox {
    display: flex;
    flex-direction: column;
    width: 100%;
    background-color: #f9f9f9;

    .cart {
        width: 1210px;
        display: flex;
        flex-direction: column;
        margin: 50px auto;
        box-shadow: 0px 0px 8px 0px #e3e3e3;

        .goodsItem {
            display: flex;
            flex-direction: row;

            .productImg {
                width: 100px;
                min-width: 100px;
                height: 100px;
                overflow: hidden;
                margin-right: 8px;
                border: 1px solid #cecece;

                img {
                    width: 100%;
                    height: 100%;
                }
            }

            .infoCol {
                display: flex;
                flex-direction: column;

                .infoRow {
                    display: flex;
                    flex-direction: row;

                    .name {
                        font-size: 13px;
                        color: #959595;
                        line-height: 18px;
                        margin-bottom: 5px;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2;
                        overflow: hidden;
                        min-height: 18px;
                    }

                    .brief {
                        color: #666666;
                        line-height: 18px;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 5;
                        overflow: hidden;
                    }
                }
            }
        }

        .pagination {
            width: 1210px;
            margin: 0 auto;
        }

        .bottomRow {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            margin-top: 20px;

            .selected {
                display: flex;
                flex-direction: row;
                align-items: center;
            }

            .red {
                color: red;
            }

            .commit {
                background-color: #1f2d5c;
                border-radius: 3px;
                color: white;
                font-size: 14px;
                padding: 20px 40px;
                cursor: pointer;
            }
        }
    }

    .noCart {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        font-size: 16px;
        color: #999;
        width: 1210px;
        height: 550px;
        margin: 50px auto;
        background-color: white;
        box-shadow: 0px 0px 5px 0px #d9d9d9;
        border-radius: 3px;

        .row1 {
            display: flex;
            flex-direction: row;
            align-items: center;
            margin: 20px 0px 5px;

            .link {
                color: #1f2d5c;
            }
        }
    }
}

</style>
